import ReactDOM from "react-dom";
import { IoCloseSharp } from "react-icons/io5";
import { useAuth } from "../../auth/AuthContext";
import moment from "moment";
import { Fragment } from "react";

export default function DepositModal({ passed, setDepositModal, deposit }) {
  console.log(deposit);
  const { darkMode } = useAuth();

  return ReactDOM.createPortal(
    <div
      className={`bg-black bg-opacity-20 z-40 w-screen h-screen fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center ${
        darkMode ? "dark" : ""
      } `}
    >
      <div
        className="bg-white mx-2 dark:bg-dark-bg dark:text-secondary-text p-10 rounded-md shadow-md flex flex-col items-center"
        ref={passed}
      >
        {/* {children} */}
        <div className="flex justify-between items-center w-full mb-5">
          <div>
            <span className="font-bold text-lg">Service Provider Details</span>
          </div>
          <div
            className="dark:hover:bg-dark-bg-600 hover:bg-accent p-2 rounded-full cursor-pointer"
            onClick={() => setDepositModal(false)}
          >
            <IoCloseSharp />
          </div>
        </div>

        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Date</p>
          <p className="font-bold col-span-3 pl-8">
            : {moment(deposit.created_at).format("DD-MM-YYYY, hh:mm a")}
          </p>
        </div>

        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Name</p>
          <p className="font-bold col-span-3 pl-8">: {deposit?.name}</p>
        </div>
        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Service</p>
          <p className="font-bold col-span-3 pl-8 capitalize">
            : {deposit?.service}
          </p>
        </div>
        <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
          <p className="col-span-1">Added by</p>
          <p className="font-bold col-span-3 pl-8 capitalize">
            : {deposit?.added_by}
          </p>
        </div>
        {deposit?.description && (
          <Fragment>
            <div className="grid grid-cols-5 gap-2 justify-start w-full">
              <p className="col-span-5">Description</p>
            </div>
            <div className="grid grid-cols-5 gap-2 mb-2 justify-start w-full">
              <p className="font-bold col-span-5 pl-8">
                {" "}
                {deposit?.description}
              </p>
            </div>
          </Fragment>
        )}
      </div>
    </div>,
    document.getElementById("portal")
  );
}
